import styles from "./Header.module.scss";
import { classNames } from "../../utils/classNames";

export const Header = ({
  header = false,
  title = false,

  light = false,
  medium = false,
  bold = false,
  black = false,

  italic = false,

  extrasmall = false,
  small = false,
  big = false,
  large = false,
  extralarge = false,

  color = null,
  activeRed = false,

  active = false,

  className = " ",
  children,
  style = {},
  nowrap = false,
  align = false,
  ...props
}) => {
  let fontSize = '1em';
  if (small) fontSize = '.7em';
  if (big) fontSize = '1.5em';
  if (large) fontSize = '2.2em';
  if (extralarge) fontSize = '2.5em';

  let fontWeight = 400;
  if (light) fontWeight = 300;
  if (medium) fontWeight = 500;
  if (bold) fontWeight = 600;
  if (black) fontWeight = 700;

  let marginTop, marginBottom;
  if (header) {
    fontSize = '2.2em';
    fontWeight = 600;
    marginTop = 0;
    marginBottom = '.2em';
  }
  if (title) {
    fontSize = '1.8em';
    fontWeight = 500;
    marginTop = '.5em';
    marginBottom = '.2em';
  }

  const fontStyle = italic ? "italic" : "";

  return (
    <div
      className={classNames(
        styles.headerText,
        styles["nowrap-" + nowrap],
        styles["active-" + active],
        styles["active-red-" + activeRed],
        className
      )}
      style={{
        fontWeight,
        fontSize,
        fontStyle,
        color: color ? `var(--${color})` : null,
        marginBottom: (title || header) ? marginBottom : null,
        marginTop: (title || header) ? marginTop : null,
        ...style,
      }}
      {...props}>
      {children}
    </div>
  );
};
